import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID, DATETIME, ITEM } from '@/plugins/sdk/fields'
import Account from '@/plugins/sdk/resources/Account'

export default class extends Resource {
  static name = 'cloud_print_settings'

  static get fields () {
    return {
      id: new UUID(),
      account: new ITEM(Account),
      api_token: new STRING(),
      default_printer: new STRING(),
      completed_at: new DATETIME(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME()
    }
  }
}
